import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { loadJudicialCases, addJudicialCases } from 'store/actions';
import { RootState } from 'store/reducers';
import { Breadcrumbs, Table } from 'components';
import { ModalWindow, columnsTable } from './components';
import { IJudicialCasesProps, IJudicialCasesItem } from './JudicialCasesTypes';
import { getDateInFormat } from 'utils/app_helper';
import { judicialCasesRenderPeopleType } from './components/JudicialCasesTable/JudicialCasesTableColumns';

const JudicialCases = ({
  areaId,
  loadJudicialCases,
  addJudicialCases,
  listJudicialCases,
}: IJudicialCasesProps) => {
  const [listCasesSorted, setListCasesSorted] = useState(listJudicialCases);
  const [searchInput, setSearchInput] = useState('');
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  useEffect(() => {
    if (areaId) {
      loadJudicialCases(areaId);
    }
  }, [loadJudicialCases, areaId]);

  useEffect(() => {
    setListCasesSorted(listJudicialCases);
  }, [listJudicialCases]);
  useEffect(() => {
    if (searchInput === '') {
      return setListCasesSorted(listJudicialCases);
    }
    const sortedArray = listJudicialCases?.filter(
      item =>
        item.uid.toString().toLowerCase().indexOf(searchInput.toLowerCase()) !==
          -1 ||
        item.case_id
          .toString()
          .toLowerCase()
          .indexOf(searchInput.toLowerCase()) !== -1 ||
        getDateInFormat(item.start)
          .toString()
          .toLowerCase()
          .indexOf(searchInput.toLowerCase()) !== -1 ||
        getDateInFormat(item?.end)
          .toString()
          .toLowerCase()
          .indexOf(searchInput.toLowerCase()) !== -1 ||
        judicialCasesRenderPeopleType(item?.plaintiff)
          .toString()
          .toLowerCase()
          .indexOf(searchInput.toLowerCase()) !== -1 ||
        judicialCasesRenderPeopleType(item?.defendant)
          .toString()
          .toLowerCase()
          .indexOf(searchInput.toLowerCase()) !== -1,
    );

    setListCasesSorted(sortedArray);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput, listJudicialCases]);

  const searchInputHandler = e => {
    setSearchInput(e.target.value);
  };

  if (areaId === undefined) {
    return null;
  }

  const modalAddHandler = (item: IJudicialCasesItem) => {
    return addJudicialCases(item, areaId);
  };

  const onHandlerModalWindow = () => {
    setIsOpenModal(isOpen => !isOpen);
  };

  return (
    <>
      <Breadcrumbs
        title='Дела судебного участка'
        breadcrumbItems={['Дела судебного участка', 'Создание']}
      />
      <Row>
        <Col xs='12'>
          <div className='judicialcases-content-wrapper'>
            <div className='judicialcases-header'>
              <div className='judicialcases-header-search'>
                <span className='me-2'>Поиск по делам : </span>
                <input
                  className='judicialcases-header-search-input'
                  type='text'
                  value={searchInput}
                  onChange={searchInputHandler}
                />
              </div>
              <div className='judicialcases-header-addbtn-wrapper'>
                <Button
                  className='judicialcases-addbtn'
                  color='primary'
                  style={{ cursor: 'pointer' }}
                  onClick={() => setIsOpenModal(true)}
                >
                  Создать дело
                </Button>
              </div>
            </div>

            <Table
              data={listCasesSorted}
              columns={columnsTable}
              keyField='id'
            />
            <ModalWindow
              isOpen={isOpenModal}
              closeHandler={onHandlerModalWindow}
              areaId={areaId}
              caseData={undefined}
              submitHandler={modalAddHandler}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};
const mapStateToProps = (state: RootState) => {
  const { areaId } = state.Profile;
  const { listJudicialCases, currentItem } = state.JudicialCases;

  return { areaId, listJudicialCases, currentItem };
};

export default connect(mapStateToProps, {
  loadJudicialCases,
  addJudicialCases,
})(withRouter(JudicialCases));
